
const observer = new MutationObserver(function () {
  const wishlistBtnWrapper = document.querySelector('.frcp-wishlist-wrapper');
  const target = document.querySelector('.product__media-gallery-viewer');

  if (wishlistBtnWrapper && target) {
    target.appendChild(wishlistBtnWrapper);
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Fix tabindex="1" injected by Froonze — tabindex=1 breaks natural tab order
(function () {
  function fixWishlistTabindex(root) {
    (root || document).querySelectorAll('.frcp-wishlist-btn[tabindex="1"]').forEach(function (el) {
      el.setAttribute('tabindex', '0');
    });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('frcp-wishlist-btn') && node.getAttribute('tabindex') === '1') {
          node.setAttribute('tabindex', '0');
        } else if (node.querySelectorAll) {
          fixWishlistTabindex(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () { fixWishlistTabindex(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('frcp-wishlist-btn')) {
      e.target.click();
    }
  });
})();

// Froonze renders the header wishlist link as a plain span with a click handler —
// make it keyboard-operable without touching Froonze's own markup/script
(function () {
  function fixWishlistNavLink(root) {
    (root || document).querySelectorAll('.frcp-wishlist-nav-link').forEach(function (el) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
    });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('frcp-wishlist-nav-link')) {
          node.setAttribute('role', 'button');
          node.setAttribute('tabindex', '0');
        } else if (node.querySelectorAll) {
          fixWishlistNavLink(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () { fixWishlistNavLink(); });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('frcp-wishlist-nav-link')) {
      e.preventDefault();
      e.target.click();
    }
  });
})();

// Focus trap for the Froonze wishlist modal — .frcp-popup__close is a div (non-focusable)
// and closing the modal otherwise drops keyboard focus back to <body>
(function () {
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), [role="button"], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var activeTrap = null;

  function isVisible(el) {
    return el.getClientRects().length > 0;
  }

  function getFocusable(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
  }

  function closeModal(modal) {
    if (!activeTrap || activeTrap.modal !== modal) return;
    var trigger = activeTrap.trigger;
    activeTrap.cleanup();
    activeTrap = null;

    var fallback = trigger && document.contains(trigger) ? trigger : document.querySelector('.frcp-wishlist-nav-link');
    if (fallback) fallback.focus();
  }

  function openModal(modal) {
    var trigger = document.activeElement;
    var closeBtn = modal.querySelector('.frcp-popup__close');

    if (closeBtn) {
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('tabindex', '0');
    }

    (closeBtn || getFocusable(modal)[0] || modal).focus();

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        if (closeBtn) {
          closeBtn.click();
        } else {
          closeModal(modal);
        }
        return;
      }
      if ((e.key === 'Enter' || e.key === ' ') && e.target === closeBtn) {
        e.preventDefault();
        closeBtn.click();
        return;
      }
      if (e.key === 'Tab') {
        var items = getFocusable(modal);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function handleClick(e) {
      if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) {
        closeModal(modal);
      }
    }

    modal.addEventListener('keydown', handleKeydown);
    modal.addEventListener('click', handleClick);

    activeTrap = {
      modal: modal,
      trigger: trigger,
      cleanup: function () {
        modal.removeEventListener('keydown', handleKeydown);
        modal.removeEventListener('click', handleClick);
      },
    };
  }

  function findModal(node) {
    if (node.classList && node.classList.contains('frcp-wishlist-modal')) return node;
    return node.querySelector ? node.querySelector('.frcp-wishlist-modal') : null;
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var modal = findModal(node);
        if (modal && (!activeTrap || activeTrap.modal !== modal)) openModal(modal);
      });
      m.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1 || !activeTrap) return;
        var removedModal = findModal(node);
        if (removedModal === activeTrap.modal || node.contains(activeTrap.modal)) {
          closeModal(activeTrap.modal);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

// Re-attach wishlist buttons after product recommendations are loaded
document.addEventListener('recommendations:loaded', () => {
  window.frcp?.wishlist?.attachOnCollection?.();
}, true);

// Sync --card-image-height CSS variable on each .product-card
(function () {
  const ro = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      const card = entry.target.closest('.product-card');
      if (card) card.style.setProperty('--card-image-height', entry.contentRect.height + 'px');
    });
  });

  function observeCards(root) {
    (root || document).querySelectorAll('.product-card__image-wrapper').forEach(function (el) {
      ro.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeCards();

    // Pick up new cards added by Globo AJAX
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('product-card__image')) {
            ro.observe(node);
          } else if (node.querySelectorAll) {
            observeCards(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
